import React, { useEffect, useState } from 'react';
import KenTextLabel from '../KenTextLabel';
import KenError from '../KenError';
import { Box, Divider, Typography } from '@mui/material';
import KenIcon from '../KenIcon';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '../../Assets/Icons/error.png';
import { MuiTelInput } from 'mui-tel-input';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  input: {
    background: '#F3F5F7',
    borderRadius: '4px',
  },
}));

export default function KenPhoneInput(props) {
  const {
    error,
    success,
    ui,
    setValue,
    hideLabel = false,
    required = false,
  } = props;
  const classes = useStyles();
  const [currentLocation, setCurrentLocation] = useState('IN');

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (res) => {
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${res?.coords?.latitude}&lon=${res?.coords?.longitude}&zoom=18&addressdetails=1`;
        fetch(url)
          .then((response) => response.json())
          .then((locationData) => {
            if (locationData?.address?.country_code) {
              const countryCode =
                locationData?.address?.country_code.toUppercase();
              if (!props.value) {
                setCurrentLocation(countryCode);
              }
            }
          })
          .catch((error) => {
            console.error('Error fetching location details:', error);
          });
      },
      (err) => {
        console.error(err);
      }
    );
  }, [props.value]);

  useEffect(() => {
    if (!props.value && setValue) {
      setValue(props.name, "");
    }
  }, [props.value, props.name]);

  return (
    <>
      {!hideLabel && (
        <KenTextLabel
          label={props.label}
          labelClassName={`${props.inputFieldLabelClass}`}
          required={required}
        />
      )}
      <Box display="flex" alignItems="flex-start" width={'-webkit-fill-available'}>
        <MuiTelInput
          {...props}
          fullWidth
          size="medium"
          forceCallingCode
          label={null}
          required={false}
          defaultCountry={currentLocation}
          className={classes.input}
        />
        {error && (
          <Box width="16px" height="16px" margin="19px 8px">
            <KenIcon
              iconType="img"
              icon={ErrorIcon}
              variant="extraSmall"
            ></KenIcon>
          </Box>
        )}
      </Box>
      {props?.error && <KenError message={props?.error} single />}
      {success && (
        <Box display="flex" alignItems="flex-start" pt={1}>
          <Typography component="span">
            {success.icon || (
              <DoneIcon fontSize="small" style={{ color: '#158467' }} />
            )}
          </Typography>
          <Typography component="span" pl={1}>
            {success.message}
          </Typography>
        </Box>
      )}
      {ui && ui?.divider && (
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
      )}
    </>
  );
}
